const PRE_EVALUATION_MONTH = 8; // Septiembre (0-based), año de inicio del curso
const POST_EVALUATION_MONTH = 5; // Junio (0-based), año siguiente al de inicio del curso

const toInputDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// El curso académico va de septiembre (año N) a junio (año N+1). Antes de
// septiembre se considera que aún pertenece al curso que empezó el año anterior.
export const resolveCursoInicio = (now = new Date()) => (
  now.getMonth() < PRE_EVALUATION_MONTH ? now.getFullYear() - 1 : now.getFullYear()
);

export const buildDefaultEvaluationRanges = (now = new Date()) => {
  const cursoInicio = resolveCursoInicio(now);
  return {
    preStart: toInputDate(new Date(cursoInicio, PRE_EVALUATION_MONTH - 1, 1)),
    preEnd: toInputDate(new Date(cursoInicio, PRE_EVALUATION_MONTH + 2, 0)),
    postStart: toInputDate(new Date(cursoInicio + 1, POST_EVALUATION_MONTH - 1, 1)),
    postEnd: toInputDate(new Date(cursoInicio + 1, POST_EVALUATION_MONTH + 2, 0)),
  };
};
